import React from "react";

import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";

import AdminMenu from "./AdminMenu";
import UserMenu from "./UserMenu";

import { useAuth } from "../../features/auth/AuthContext";
import SideLogo from "../SideLogo";

const rolesMenus = {
	user: UserMenu,
	"branch-manager": AdminMenu,
	admin: AdminMenu,
};

function SideMenu() {
	const { user } = useAuth();

	return (
		<Drawer
			sx={{
				width: 52,
				flexShrink: 0,
				"& .MuiDrawer-paper": {
					width: 52,
					boxSizing: "border-box",
					background: (theme) => theme.palette.barColor,
				},
				"& .MuiListItemButton-root": {
					paddingTop: "14px",
					paddingBottom: "14px",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					"& img": {
						objectFit: "contain",
						width: "100%",
					},
				},
				"& a.active": {
					background: (theme) => theme.palette.primary.main,
				},
			}}
			variant="permanent"
			anchor="left"
		>
			<Toolbar variant="dense" />
			{rolesMenus[user.role]
				? React.createElement(rolesMenus[user.role])
				: null}
			<SideLogo />
		</Drawer>
	);
}
export default SideMenu;
